package music.jammers.shared.instrument.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class InstrumentType {

    VOCAL,
    GUITAR,
    BASS,
    PIANO,
    DRUMS,
}